/**
 * Base-Implementierung des Help-Service
 * Stellt die Grundfunktionalität für Hilfetexte, -listen und Picker bereit.
 * Die App-spezifische Implementierung registriert die konkreten Inhalte.
 */

import { Injectable } from '@angular/core';
import { IHelpService } from '../../core/interfaces';

@Injectable()
export abstract class BaseHelpService implements IHelpService {
	protected helpText_ = new Map<string, string>();
	protected helpList_ = new Map<string, { value: string; name: string }[]>();
	protected helpPicker_ = new Set<string>();

	/** Registriert einen Hilfetext für ein Feld */
	protected registerText(key: string, text: string): void {
		this.helpText_.set(key, text);
	}

	/** Registriert eine Hilfsliste für ein Feld */
	protected registerList(key: string, list: { value: string; name: string }[]): void {
		this.helpList_.set(key, list);
	}

	/** Registriert einen Picker für ein Feld (auch mit Array-Index nutzbar) */
	protected registerPicker(key: string): void {
		this.helpPicker_.add(key);
	}

	has(key: string): boolean {
		return this.helpText_.has(key) || this.helpList_.has(key) || this.hasPicker(key);
	}

	text(key: string): string | undefined {
		return this.helpText_.get(key);
	}

	list(key: string): { value: string; name: string }[] | undefined {
		return this.helpList_.get(key);
	}

	hasList(key: string): boolean {
		return this.helpList_.has(key);
	}

	hasPicker(key: string): boolean {
		for (const picker of this.helpPicker_) {
			if (key === picker || key.startsWith(picker + '[')) {
				return true;
			}
		}
		return false;
	}

	getPickerName(key: string): string | undefined {
		for (const picker of this.helpPicker_) {
			if (key === picker || key.startsWith(picker + '[')) {
				return picker;
			}
		}
		return undefined;
	}
}
